<div class="loader" *ngIf="!isTranslateLoaded">
  <app-skeleton-loader
    mode="initiativeCard"
    *ngFor="let item of [1, 2, 3, 4, 5]"
  ></app-skeleton-loader>
</div>
